<template>
  <div>
    <el-row type="flex" justify="end" class="title-bar">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper ref="e2eTable" border :data="tableDatas" :columns="columns" :show-custom-header="true"
      :show-search-tool="showSearchTool" :show-overflow-tooltip="true" :span-method="objectSpanMethod"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template #obj-name-slot="scope">
          <span v-if="scope.row.serviceName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.serviceName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import commonAPI from '@/api/performance/common';
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { isNil, isEmpty } from 'lodash';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WE2EPerfTable',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [
        { prop: 'serviceName', sortable: false, sortProp: 'h.service_name', scopedSlot: 'obj-name-slot', remoteProp: 'ets.service_name', label: 'E2E 서비스명', headerAlign: 'center', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'httpUrl', sortable: false, sortProp: 'h.http_url', remoteProp: 'ets.http_url', label: 'URL', headerAlign: 'center', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'protocol', sortable: false, sortProp: 'h.protocol', remoteProp: 'ets.protocol', label: '프로토콜', headerAlign: 'center', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'agentName', sortable: false, sortProp: 'CONCAT(h.obj_name, h.obj_id)', remoteProp: 'o.obj_name', label: '에이전트명', headerAlign: 'center', searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'SERVICESTATUS/SERVICE_STATUS_CODE', sortable: false, label: '응답코드', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
        { label: '응답시간',
          headerAlign: 'center',
          childColumns: [
            { prop: 'SERVICESTATUS/RESPONSETIME_TOTAL', sortable: false, label: '전체 응답시간', headerAlign: 'center', formatter: this.convertValue },
            { prop: 'SERVICESTATUS/RESPONSETIME_NAMELOOKUP', sortable: false, label: 'DNS(네임서버)', headerAlign: 'center', formatter: this.convertValue },
            { prop: 'SERVICESTATUS/RESPONSETIME_HOST_SERVER_CONNECT', sortable: false, label: '호스트연결', headerAlign: 'center', formatter: this.convertValue },
            { prop: 'SERVICESTATUS/RESPONSETIME_SERVICE_WAIT', sortable: false, label: '서비스대기', headerAlign: 'center', formatter: this.convertValue },
            { prop: 'SERVICESTATUS/RESPONSETIME_FILE_TRANSFER', sortable: false, label: '파일전송', headerAlign: 'center', formatter: this.convertValue },
            { prop: 'SERVICESTATUS/RESPONSETIME_DB_SERVICE', sortable: false, label: 'DB연결', headerAlign: 'center', formatter: this.convertValue },
          ],
        },
      ],
      EMPTY_TEXT,
    };
  },
  computed: mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.e2eTable === undefined) {
          this.$nextTick(() => {
            this.$refs.e2eTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.e2eTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.e2eTable.getParameter();
        const params = {
          managegroupIds: this.selectedNode.childManagegroupIds,
          managetypeId: 'E2E',
          objDefineId: this.selectedObjDefineIds[0],
          objtypeId: this.selectedNode.objtypeId,
          treeType,
          ...tableParams,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objtypeIds = this.selectedObjDefineIdsForPhysical;
        }
        commonAPI
          .getPerformanceE2EGroupList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableDatas = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [getStringtoNumber String형 Number형으로 변경]
     * @author {Yang}
     */
    getStringtoNumber(value) {
      return Number(value);
    },
    /**
     * [objectSpanMethod 병합 메서드]
     * @author {Yang}
     * @param  {[type]} row         [description]
     * @param  {[type]} columnIndex [description]
     * @param  {[type]} }           [description]
     * @return {[type]}             [description]
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (!isNil(row.rowCount)) {
          return { rowspan: row.rowCount, colspan: 1 };
        }
        return { rowspan: 1, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.serviceId)) {
        routePathByObjId(this, row.serviceId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/E2EPerfTable.vue